<h5 class="titulo">Identificação do equipamento</h5>
<form class="form" [formGroup]="form" (submit)="prosseguir()">
  <label class="form__label">Patrimônio/Número de Série/Produto *
    <app-select-auto-complete [dados]="equipamentos.registros" [filtrar]="filtrarEquipamentos"
      [exibir]="exibirEquipamento" [valor]="valorEquipamento" [formControl]="equipamentoControl"
      [funcaoDeComparacao]="comparaEquipamento" required></app-select-auto-complete>
  </label>
  <div class="form__input-duplo">
    <label class="form__label u-width-47_5-percent" for="contpb">
      Cont. P/B *
      <input class="form__input" type="text" placeholder="Digite aqui..." formControlName="contpb" mask="0*">
    </label>
    <label class="form__label u-width-47_5-percent" for="contcolor">
      Cont. Color *
      <input class="form__input" type="text" placeholder="Digite aqui..." formControlName="contcolor" mask="0*">
    </label>
  </div>
  <label class="form__label" for="obs">Solicitação * 
    <textarea class="form__input u-height-8-rem u-padding-vertical-1-rem" placeholder="Digite aqui..."
      formControlName="obs" required maxlength="5000"></textarea>
  </label>
  <app-botao-submit [disabled]="form.invalid">Continuar</app-botao-submit>
</form>
<app-indicador-circular-paginacao class="progresso" [quantidadeDePaginas]="3"
  [paginaAtiva]="1"></app-indicador-circular-paginacao>
